import { __decorate } from "tslib";
import _ from 'lodash';
import { injectable } from '@/inversify.config';
import { getCopyPermissionAndSetting, getFieldDetailByFieldId } from '@cores/apis/workspace_api/patents';
const WORKSPACE_COPY_CUSTOM_FIELD = 'WORKSPACE_COPY_CUSTOM_FIELD';
export const CopyFieldAndCommentsServiceSymbol = Symbol.for('CopyFieldAndCommentsService');
let CopyFieldAndCommentsService = class CopyFieldAndCommentsService {
    constructor() {
        this.apiKey = 0;
        this.loading = true;
        this.popLoading = true;
        this.src_folder_ids = [];
        this.fieldDetail = [];
        this.fieldType = '';
        // owner全量的自定义字段
        this.CustomFieldList = [];
        // 选中的自定义字段 初始化的时候push进去即可
        this.checkedCustomFieldList = [];
        // 是否开启custom
        this.CustomFieldSwitchOpen = false;
        // 是否开启注释
        this.CommentsSwitchOpen = false;
        // 是否开启custom/注释权限
        this.CopyInSpacePem = true;
        // 是否开启custom权限
        this.CustomFieldSwitchOpenPem = false;
        // 是否开启注释权限
        this.CommentsSwitchOpenPem = false;
        // 专利数量容量上限
        this.PatentOverLimit = false;
        // 专利数量容量上限数量
        this.PatentOverCount = 0;
        this.dupAction = 'NEW';
        this.dupActionType = 'NEW';
        this.copAction = 'NEW';
        this.CustomFieldOverCount = 0;
        // 需要进行合并 操作
        this.isInMergeMode = false;
        // 复制过的folderList
        this.copiedList = [];
        // 复制映射map
        this.src_copied_field_to_dst_field_map = {};
        // 重复的folderlist
        this.duplicateList = [];
        // 目标自定义字段列表
        this.dstFieldsInfo = [];
        // 拷贝映射map
        this.src_duplicate_field_to_dst_field_map = {};
    }
    // 自定义字段个数限制
    get CustomFieldOverLimitError() {
        const count = this.checkedCustomFieldList.length - this.checkedCopiedList.length - this.checkedDuplicateList.length;
        return count > this.CustomFieldOverCount && this.CustomFieldSwitchOpen;
    }
    // 自定义字段个数限制
    get PatentOverLimitError() {
        return this.PatentOverLimit && (this.CustomFieldSwitchOpen || this.CommentsSwitchOpen);
    }
    // 新建时创建限制
    get CustomFieldNewLimitError() {
        return this.checkedCustomFieldList.length - this.checkedCopiedList.length > this.CustomFieldOverCount && this.dupActionType === 'NEW' && this.isInMergeMode;
    }
    // 命中的 复制过的folderList
    get checkedCopiedList() {
        const list = [];
        _.forEach(this.copiedList, fieldId => {
            _.forEach(this.checkedCustomFieldList, item => {
                if (item.field_id === fieldId) {
                    list.push(item);
                }
            });
        });
        return list;
    }
    // 命中的 重复的folderList
    get checkedDuplicateList() {
        const list = [];
        _.forEach(this.duplicateList, fieldId => {
            _.forEach(this.checkedCustomFieldList, item => {
                if (item.field_id === fieldId) {
                    list.push(item);
                }
            });
        });
        return list;
    }
    // 存入本地选中自定义字段
    logCustomFieldList(list) {
        localStorage.setItem(WORKSPACE_COPY_CUSTOM_FIELD, JSON.stringify(list));
    }
    getNeedMergeMode() {
        if (this.isInMergeMode)
            return false;
        return this.CustomFieldSwitchOpen && (this.checkedCopiedList.length > 0 || this.checkedDuplicateList.length > 0);
    }
    getCheckStatus(field_id) {
        return _.findIndex(this.checkedCustomFieldList, field => field.field_id === field_id) > -1;
    }
    onClickCustomFieldListItem(field) {
        const index = _.findIndex(this.checkedCustomFieldList, item => item.field_id === field.field_id);
        if (index > -1) {
            this.checkedCustomFieldList.splice(index, 1);
        }
        else {
            this.checkedCustomFieldList.push(field);
        }
        this.CustomFieldSwitchOpen = true;
        const list = _.map(this.checkedCustomFieldList, i => i.field_id);
        this.logCustomFieldList(list);
    }
    SwitchCustomField() {
        this.CustomFieldSwitchOpen = !this.CustomFieldSwitchOpen;
    }
    SwitchComments() {
        this.CommentsSwitchOpen = !this.CommentsSwitchOpen;
    }
    // 找到目标对应的不合法字段
    getTragetValidationField(field_id, type) {
        if (type === 'cop') {
            return _.find(this.dstFieldsInfo, field => field.field_id === this.src_copied_field_to_dst_field_map[field_id]);
        }
        else {
            return _.find(this.dstFieldsInfo, field => field.field_id === this.src_duplicate_field_to_dst_field_map[field_id]);
        }
    }
    getFieldDetailByFieldId(field, type) {
        this.popLoading = true;
        this.fieldDetail = [];
        const params = {
            space_id: type === 'target' ? this.dst_space_id : this.src_space_id,
            folder_id: type === 'target' ? this.dst_folder_id : this.src_folder_ids[0],
            field_id: field,
        };
        getFieldDetailByFieldId(params).then(res => {
            const { field_type, field_option_value, field_layer_value } = res;
            if (field_type === 'OPTION') {
                this.fieldDetail = field_option_value;
            }
            else {
                this.fieldDetail = field_layer_value;
            }
            this.fieldType = field_type;
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            this.popLoading = false;
        });
    }
    getCopyPermissionAndSetting(params) {
        this.apiKey++;
        const apiKey = this.apiKey;
        this.loading = true;
        const { dst_folder_id, dst_space_id, src_folder_ids, src_space_id } = params;
        this.dst_folder_id = dst_folder_id;
        this.dst_space_id = dst_space_id;
        this.src_folder_ids = src_folder_ids;
        this.src_space_id = src_space_id;
        getCopyPermissionAndSetting(params).then(res => {
            if (apiKey !== this.apiKey) {
                return;
            }
            /** Part2 */
            // 判断高级设置权限
            const copy_field_comment_per = _.get(res.data, 'copy_field_comment_per', {});
            this.CopyInSpacePem = copy_field_comment_per.copy_in_same_space;
            this.CustomFieldSwitchOpenPem = copy_field_comment_per.can_copy_field;
            this.CommentsSwitchOpenPem = copy_field_comment_per.can_copy_comment;
            this.PatentOverLimit = _.get(res.data, 'exceed_max_patent_count', false);
            this.PatentOverCount = _.get(res.data, 'max_patent_count_for_field_comment', 0).toLocaleString();
            if (this.CopyInSpacePem)
                return;
            /** Part1 */
            // 1.获取全量自定义字段
            const fields_structure = _.get(res.data, 'fields_structure', []);
            // 2.获取可视自定义字段 优先用 loacl 其次再用 visible_fields 并且勾选
            let visible_fields = [];
            const localFieldList = JSON.parse(localStorage.getItem(WORKSPACE_COPY_CUSTOM_FIELD)) || [];
            if (localFieldList.length !== 0) {
                visible_fields = _.uniq(localFieldList);
            }
            else {
                visible_fields = _.uniq(_.get(res.data, 'visible_fields', []));
            }
            _.forEach(visible_fields, id => {
                if (fields_structure[id]) {
                    this.checkedCustomFieldList.push(fields_structure[id]);
                }
            });
            const list = _.map(this.checkedCustomFieldList, i => i.field_id) || [];
            if (this.CustomFieldSwitchOpenPem) {
                this.logCustomFieldList(list);
            }
            // 3. 设置tag
            // 取出映射map
            this.src_copied_field_to_dst_field_map = _.get(res.data, 'copy_fields_info.src_copied_field_to_dst_field_map', {});
            this.src_duplicate_field_to_dst_field_map = _.get(res.data, 'copy_fields_info.src_duplicate_field_to_dst_field_map', {});
            this.copiedList = Object.keys(this.src_copied_field_to_dst_field_map);
            this.duplicateList = Object.keys(this.src_duplicate_field_to_dst_field_map);
            this.dstFieldsInfo = _.get(res.data, 'dst_fields_info.custom_field', []);
            _.forEach(this.copiedList, id => {
                fields_structure[id].tag = 'cop';
            });
            _.forEach(this.duplicateList, id => {
                fields_structure[id].tag = 'dup';
            });
            // 4.自定义字段列表 可能需要去掉filter
            this.CustomFieldList = _.filter(fields_structure, field => field.is_custom === true);
            /** Part3 */
            // 计算对方可用容量
            const copy_fields_info = _.get(res.data, 'copy_fields_info', {});
            const total = copy_fields_info.dst_total_field_capacity;
            const usedCount = copy_fields_info.dst_used_field_number;
            this.CustomFieldOverCount = total - usedCount;
            // available_custom_fields
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            this.loading = false;
        });
    }
    reset() {
        this.dst_folder_id = '';
        this.dst_space_id = '';
        this.src_folder_ids = [];
        this.src_space_id = '';
        this.checkedCustomFieldList = [];
        this.copiedList = [];
        this.duplicateList = [];
        this.CustomFieldList = [];
        this.CopyInSpacePem = true;
        this.CustomFieldSwitchOpenPem = false;
        this.CommentsSwitchOpenPem = false;
        this.CustomFieldOverCount = 0;
        this.src_copied_field_to_dst_field_map = {};
        this.src_duplicate_field_to_dst_field_map = {};
        this.dstFieldsInfo = [];
        this.isInMergeMode = false;
        this.fieldDetail = [];
        this.loading = false;
        this.popLoading = false;
        this.dupAction = 'NEW';
        this.dupActionType = 'NEW';
        this.copAction = 'NEW';
        this.CustomFieldSwitchOpen = false;
        this.CommentsSwitchOpen = false;
    }
    // 数组生成一个map
    listToMap(list, type) {
        const map = {};
        _.forEach(list, id => {
            const targerId = this.getTragetValidationField(id, type).field_id;
            if (targerId) {
                map[id] = targerId;
            }
        });
        return map;
    }
    dealWithData() {
        const copiedList = _.map(this.checkedCopiedList, item => item.field_id);
        const duplist = _.map(this.checkedDuplicateList, item => item.field_id);
        const select_field_ids = _.map(this.checkedCustomFieldList, item => item.field_id);
        const copy_field_comment_request = {
            copied_field_setting: {
                operate_field_type: {
                    field_def_type: 'MERGE',
                    field_value_type: this.copAction,
                },
                select_merge_field_id_map: this.listToMap(copiedList, 'cop'),
            },
            dup_field_setting: {
                operate_field_type: {
                    field_def_type: this.dupActionType,
                    field_value_type: this.dupActionType === 'NEW' ? 'ALL' : this.dupAction,
                },
                select_merge_field_id_map: this.listToMap(duplist, 'dup'),
            },
            need_copy_comment: this.CommentsSwitchOpen,
            select_field_ids: this.CustomFieldSwitchOpen ? select_field_ids : [],
        };
        return copy_field_comment_request;
    }
};
CopyFieldAndCommentsService = __decorate([
    injectable()
], CopyFieldAndCommentsService);
export { CopyFieldAndCommentsService };
